var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9634",
    "data-name": "Group 9634",
    transform: "translate(-14750.24 22727)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5205",
    "data-name": "Rectangle 5205",
    width: 16,
    height: 3,
    rx: 1.5,
    transform: "translate(14750.24 -22727)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5206",
    "data-name": "Rectangle 5206",
    width: 16,
    height: 3,
    rx: 1.5,
    transform: "translate(14750.24 -22721)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5207",
    "data-name": "Rectangle 5207",
    width: 16,
    height: 3,
    rx: 1.5,
    transform: "translate(14750.24 -22715)",
    fill: "#1d1d26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenuIcon);
export default __webpack_public_path__ + "static/media/HamburgerMenuIcon.78257cd6fc385febe35935d708a0321b.svg";
export { ForwardRef as ReactComponent };